import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './pages/HomePage';

import AdminPage from './pages/AdminPage';

import Navbar from './components/Navbar';

import Hero from './components/Hero';

import Card from './components/Card';

import MemberCard from './components/MemberCard';

import Footer from './components/Footer';


function App() {

return (

<Router>

<div className="App">

<Routes>

<Route path="/" element={<HomePage />} />

<Route path="/admin" element={<AdminPage />} />



</Routes>

</div>

</Router>

);

}


export default App;

